import async from "./components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

import Page404 from "./components/error/Page404";
import BillDetails from "./features/bills/BillDetails";
import BillList from "./features/bills/BillList";
import Payees from "./features/payees";
import Payments from "./features/payments";
import Taxes2025 from "./features/taxes2025";
import PayeeDetails from "./features/payees/PayeeDetails";
import Invoices from "./features/invoices/invoices";
import CSITipaltiStagingList from "./features/csiTipaltiStaging/CSITipaltiStagingList";
import ConnectQuickBooksCompanies from "./features/quickbooks/ConnectQuickBooksCompanies";
import Maintenance from "./features/maintenance";

// Dashboard components
const Dashboard = async(() => import("./features/dashboard"));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "invoices",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Invoices />,
      },
    ],
  },
  {
    path: "bills",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <BillList />,
      },
      {
        path: "detail/:billRefCode",
        element: <BillDetails />,
      },
    ],
  },

  {
    path: "payees",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Payees />,
      },
      {
        path: "detail/:id",
        element: <PayeeDetails />,
      },
    ],
  },
  {
    path: "payments",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Payments />,
      },
    ],
  },
  {
    // AB#6563: access is decided by the API's operator allow-list; the page redirects otherwise.
    path: "maintenance",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Maintenance />,
      },
    ],
  },
  {
    path: "taxes2025",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute allowedRoles={["Admin", "Developer"]}>
            <Taxes2025 />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "csitipalti",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute allowedRoles={["Admin", "Developer"]}>
            <CSITipaltiStagingList />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "quickbooks-companies",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute allowedRoles={["Admin", "Developer"]}>
            <ConnectQuickBooksCompanies />
          </ProtectedRoute>
        ),
      },
    ],
  },
  /* {
    path: "applications",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <Applications />,
      },
    ],
  },
  {
    path: "clients",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <ClientList />,
      },
    ],
  },
  {
    path: "programs",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <ProgramList />,
      },
    ],
  }, */
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
